import { PDF_BORDER, ReportPage, ReportTable } from '@/components';
import type { LocalGovernmentFundTableProps } from '@/features/mold/utils/pdf/pdf-components-props';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const LocalGovernmentFundTableAFormat: FC<
  LocalGovernmentFundTableProps
> = ({ fiscalYear, header, rowData, footer, paperSize, dateByCreated }) => {
  const { t } = useTranslation();

  return (
    <ReportPage
      title={{
        text: t('report-local-government-fund-table-A-title', {
          year: fiscalYear,
        }),
      }}
      layout={{
        paperSize,
        orientation: 'landscape',
      }}
      caption={{
        unit: 'thousand',
      }}
      pagePadding={10}
      dateByCreated={dateByCreated}
    >
      <ReportTable
        header={header}
        data={rowData}
        footer={footer}
        tableWidth="100%"
        defaultBorderStyle={PDF_BORDER.THIN}
        borderColor="secondary"
      />
    </ReportPage>
  );
};
